module.exports = "/_next/static/images/sebastian-martinez@2x-dbfd04f147d78b06ff9500867b054a1f.png";